import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import {
    selectItemById,
    getBannerById,
    updateBanner,
    updateBannerImage,
} from 'app/redux/store/features/banners'
import UpdateBannerBarForm from './UpdateBannerBarForm'

function toStartOfDay(value) {
    if (value == null) return value
    const d = value instanceof Date ? new Date(value.getTime()) : new Date(value)
    if (isNaN(d.getTime())) return value
    d.setHours(0, 0, 0, 0)
    return d
}

const UpdateBannerBar = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { state } = useLocation()
    const { id } = state
    const { banners, loading, error } = useSelector((state) => state.banners)
    const banner = selectItemById(banners, id)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(banner.id)) dispatch(getBannerById({ id: id }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Banner Bar updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/configuration/banner-bar')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onUpdateBannerBar = () => {
        setApiCallInProgress(true)
        dispatch(
            updateBanner({
                ...banner,
                dateStart: toStartOfDay(banner.dateStart) ?? banner.dateStart,
                dateEnd: banner.dateEnd,
            })
        )
    }

    const onReplaceImage = (bannerData, file) => {
        if (!file) return
        const form = new FormData()
        form.append('Id', bannerData.id)
        form.append('Image', file)
        setApiCallInProgress(true)
        dispatch(updateBannerImage(bannerData.id, form, { 'Content-Type': 'multipart/form-data' }))
    }

    return (
        <React.Fragment>
            <UpdateBannerBarForm
                bannerBarData={banner}
                updateBannerBar={onUpdateBannerBar}
                onReplaceImage={onReplaceImage}
            />
        </React.Fragment>
    )
}

export default UpdateBannerBar
